import { dateFormatServer } from '@alluradirect/react';

import dayjs from 'dayjs';

/** Fetch 1 Month in the past */
export function calculateInitialStartDate(): Date {
  return dayjs().subtract(1, 'month').startOf('month').toDate();
}

/** We Fetch 1 year in the future */
export function calculateInitialEndDate(): Date {
  return dayjs().add(1, 'year').endOf('month').toDate();
}

// This function is used to generate the default start/end dates for calendar dates/events
export const calculateCalendarInitialDates = () => {
  const defaultStart = dateFormatServer(calculateInitialStartDate());
  const defaultEnd = dateFormatServer(calculateInitialEndDate());

  return { defaultStart, defaultEnd };
};
